export const SYMPTOM_TIPS = {
  Cramps: {
    tip: "Warmth helps: try a heating pad or a warm bath for your lower belly. Gentle stretching, a short walk and plenty of water can ease the pain. Over-the-counter pain relief like ibuprofen may help if it's safe for you.",
    doctor: "If cramps stop you from doing everyday things or pain relief doesn't help, talk to a doctor. Conditions like endometriosis are treatable.",
  },
  Bloating: { tip: "Go easy on salty and fizzy foods, drink more water, and try peppermint or ginger tea with a short walk after meals." },
  Headache: {
    tip: "Drink water, keep regular meals and sleep, and rest somewhere dark and quiet. Magnesium-rich foods like leafy greens and pumpkin seeds may help with hormone-linked headaches.",
    doctor: "Get urgent care for a sudden, severe headache or one that comes with vision changes.",
  },
  "Breast tenderness": { tip: "A soft, supportive bra and warm or cool compresses can help. Cutting back on caffeine and salt in the days before your period may ease soreness." },
  Acne: { tip: "Cleanse gently twice a day, avoid picking, and choose non-comedogenic products. Salicylic acid or benzoyl peroxide can help calm breakouts." },
  "Back pain": { tip: "Use heat, try gentle stretches like child's pose or cat-cow, and keep moving with short walks. Go easy on heavy lifting." },
  Cravings: { tip: "Regular meals with protein and fibre keep your blood sugar steady. When sweet cravings hit, dark chocolate, dates or a handful of nuts can satisfy them." },
  Fatigue: {
    tip: "Protect your sleep, get daylight early in the day, and eat iron-rich foods like lentils, spinach or red meat alongside vitamin C.",
    doctor: "Ongoing tiredness with heavy periods can be a sign of low iron. Ask your doctor about a blood test.",
  },
  Nausea: {
    tip: "Eat small, bland meals, sip water slowly, and try ginger tea or ginger chews.",
    doctor: "If there's a chance you could be pregnant, consider taking a test.",
  },
  Insomnia: { tip: "Keep your room cool and dark, go to bed at a steady time, and skip caffeine after midday. A warm bath or herbal tea can help you wind down." },
  Discharge: {
    tip: "Changes through the month are normal: clear and stretchy around ovulation, thicker afterwards. Breathable cotton underwear helps.",
    doctor: "See a doctor if it has a strong smell, itches or burns, or turns green, grey or yellow.",
  },
  "Low libido": { tip: "Desire naturally rises and falls across your cycle. Rest, stress care and open conversations with your partner all help." },
};

export const FLOW_TIPS = {
  Heavy: {
    tip: "Change products regularly, stay hydrated and eat iron-rich foods to replace what you lose.",
    doctor: "If you soak a pad or tampon every hour for several hours, or pass clots larger than a coin, check in with a doctor.",
  },
};

const LOW_MOOD = {
  tip: "Be gentle with yourself: slow breathing, a walk outside and talking to someone you trust can all lift your mood.",
  doctor: "If low mood or anxiety before your period feels overwhelming, talk to a doctor about PMDD. It's common and treatable.",
};

export const MOOD_TIPS = { Anxious: LOW_MOOD, Irritable: LOW_MOOD, Sad: LOW_MOOD, Tired: { tip: SYMPTOM_TIPS.Fatigue.tip } };
